<form [formGroup]="consumptionPlaceForm" class="needs-validation" novalidate>
    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{networkOperator}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <label>{{consumptionPlaceAddress}}</label>
        <div class="col-xl-5 col-md-5">
            <textarea class="input" rows="4" [disabled]="true"></textarea>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{clc}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>

    <div class="form-group row">
        <div class="col-xl-4 col-md-4">
            <label>{{serviceContract}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractionType" [disabled]="true">
                {{throughSupplier}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractionType" [disabled]="true">
                {{directly}}
            </label>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{contractType}}</label>
        </div>
        <div class="col-xl-5 col-md-5">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractType" checked="true" [disabled]="true">
                {{distribution}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractType" [disabled]="true">
                {{transport}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractType" [disabled]="true">
                {{accessToUpstreamSupplyLines}}
            </label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label>{{contractNo}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{contractDate}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="date" required [disabled]="true" onkeydown="return false">
        </div>
    </div>

    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{conventionExists}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" checked="true" [disabled]="true">
                {{yes}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" [disabled]="true">
                {{no}}
            </label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label>{{conventionNo}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-2 col-md-2">
            <label>{{conventionDate}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="date" required [disabled]="true" onkeydown="return false">
        </div>
    </div>


    <div class="form-group row">
        <div class="col-xl-2 col-md-2">
            <label>{{conventionParties}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <textarea class="input" rows="4" [disabled]="true"></textarea>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label class="d-block" for="chk-ani">
                <input class="checkbox_animated" id="suppliers" type="checkbox" checked="true" [disabled]="true">
                {{multipleSuppliers}}
            </label>
        </div>
        <textarea class="input" rows="4" [disabled]="true"></textarea>
    </div>

    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label class="d-block" for="chk-ani">
                <input class="checkbox_animated" id="technicalConnectionApproval" type="checkbox" checked="true"
                    [disabled]="true">
                {{technicalConnectionApproval}}
            </label>
        </div>
        <div class="col-xl-1 col-md-1">
            <label>{{number}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-1 col-md-1">
            <label>{{date}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="date" required [disabled]="true" onkeydown="return false">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label class="d-block" for="chk-ani">
                <input class="checkbox_animated" id="accessAgreement" type="checkbox" checked="true" [disabled]="true">
                {{accessAgreement}}
            </label>
        </div>
        <div class="col-xl-1 col-md-1">
            <label>{{number}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-1 col-md-1">
            <label>{{date}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="date" required [disabled]="true" onkeydown="return false">
        </div>
    </div>

    <div class="form-group row">
        <div class="col-xl-4 col-md-4">
            <label>{{intelligentMeasurementSystem}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" checked="true" [disabled]="true">
                {{yes}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" [disabled]="true">
                {{no}}
            </label>
        </div>
        <label>{{counterType}}</label>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <label>{{counterSeries}}</label>
        <div class="col-xl-2 col-md-2">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{consumptionPlaceStatus}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" checked="true" [disabled]="true">
                {{connected}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" [disabled]="true">
                {{disconnected}}
            </label>
        </div>
        <label>{{networkType}}</label>
        <div class="col-xl-4 col-md-4">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" checked="true" [disabled]="true">
                {{distribution}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" [disabled]="true">
                {{transport}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="convention" [disabled]="true">
                {{upstreamSupplyLine}}
            </label>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{consumptionCategory}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-3 col-md-3">
            <label>{{approvedDebit}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{reservedCapacity}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-3 col-md-3">
            <label>{{pressureCf}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{minimumPressure}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
        <div class="col-xl-3 col-md-3">
            <label>{{maximumPressure}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{minimumTechnologicalPressure}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label>{{prosumerQuality}}</label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractionType" [disabled]="true">
                {{yes}}
            </label>
            <label class="d-block">
                <input class="radio_animated" type="radio" name="contractionType" [disabled]="true">
                {{no}}
            </label>
        </div>
        <div class="col-xl-2 col-md-2">
            <label>{{indexReadingFrequency}}</label>
        </div>
        <div class="col-xl-3 col-md-3">
            <input class="form-control" type="text" required [disabled]="true">
        </div>
    </div>
</form>